import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';
import classNames from 'classnames';
import CloseIcon from 'react-material-icons/icons/navigation/close';
import './index.css';

// Unit test stuff
export const TEXT_CONTENT_ID = 'NOTIFICATION_BAR_TEXT_CONTENT';

const propTypes = {
  style: PropTypes.object,
  onClose: PropTypes.func,
};

const defaultProps = {
  style: {},
  onClose: null,
};

class NotificationBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDanger: false,
      isOpened: false,
      message: '',
    };
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  notify = (message, isDanger) => {
    // this is used externally via ref
    this.setState({ isOpened: true, message, isDanger });

    this.timeout = setTimeout(this.close, 10000);
  };

  close = () => {
    const { onClose } = this.props;

    if (onClose) {
      onClose();
    }

    this.setState({ isOpened: false, message: '' });
  };

  renderNotificationBar = () => {
    const { style } = this.props;
    const { isOpened, message, isDanger } = this.state;
    const barClass = classNames('NotificationBar', {
      'NotificationBar--danger': isDanger,
    });

    if (isOpened) {
      return (
        <div className={barClass} style={style}>
          <span id={TEXT_CONTENT_ID}>{message}</span>
          <div onClick={this.close} className="NotificationBar__close_btn">
            <CloseIcon className="NotificationBar__close_btn_icon" />
          </div>
        </div>
      );
    }

    return null;
  };

  render() {
    return (
      <CSSTransitionGroup
        transitionName="NotificationBar-animation"
        transitionEnterTimeout={375}
        transitionLeaveTimeout={300}
      >
        {this.renderNotificationBar()}
      </CSSTransitionGroup>
    );
  }
}

NotificationBar.propTypes = propTypes;
NotificationBar.defaultProps = defaultProps;

export default NotificationBar;



// WEBPACK FOOTER //
// ../ui-components/components/NotificationBar/index.jsx